// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pro-overlay[data-v-d5a1334e]{position:absolute;top:0}.badge[data-v-d5a1334e]{border-radius:10px}", ""]);
// Exports
module.exports = exports;
